import { DASHBOARD } from "./types"

export const getStatsRequest = (data) => ({
  type: DASHBOARD.GET_STATS_REQUEST,
  payload: data
})

export const getStatsSuccess = (data) => ({
  type: DASHBOARD.GET_STATS_SUCCESS,
  payload: data
})

export const getStatsFailure = (error) => ({
  type: DASHBOARD.GET_STATS_FAIL,
  payload: error
})

export const getApplicantsStatusRequest = (data) => ({
  type: DASHBOARD.GET_APPLICANTS_STATUS_REQUEST,
  payload: data
})

export const getApplicantsStatusSuccess = (data) => ({
  type: DASHBOARD.GET_APPLICANTS_STATUS_SUCCESS,
  payload: data
})

export const getApplicantsStatusFailure = (error) => ({
  type: DASHBOARD.GET_APPLICANTS_STATUS_FAIL,
  payload: error
})

export const getApplicantsReportRequest = (data) => ({
  type: DASHBOARD.GET_APPLICANTS_REPORT_REQUEST,
  payload: data
})

export const getApplicantsReportSuccess = (data) => ({
  type: DASHBOARD.GET_APPLICANTS_REPORT_SUCCESS,
  payload: data
})

export const getApplicantsReportFailure = (error) => ({
  type: DASHBOARD.GET_APPLICANTS_REPORT_FAIL,
  payload: error
})

export const getTotalJobsAndApplicantRequest = (data) => ({
  type: DASHBOARD.GET_TOTAL_JOBS_AND_APPLICANT_REQUEST,
  payload: data
})

export const getTotalJobsAndApplicantSuccess = (data) => ({
  type: DASHBOARD.GET_TOTAL_JOBS_AND_APPLICANT_SUCCESS,
  payload: data
})

export const getTotalJobsAndApplicantFailure = (error) => ({
  type: DASHBOARD.GET_TOTAL_JOBS_AND_APPLICANT_FAIL,
  payload: error
})

export const getTotalApplicantsReportsRequest = (data) => ({
  type: DASHBOARD.GET_TOTAL_APPLICANTS_REPORTS_REQUEST,
  payload: data
})

export const getTotalApplicantsReportsSuccess = (data) => ({
  type: DASHBOARD.GET_TOTAL_APPLICANTS_REPORTS_SUCCESS,
  payload: data
})

export const getTotalApplicantsReportsFailure = (error) => ({
  type: DASHBOARD.GET_TOTAL_APPLICANTS_REPORTS_FAIL,
  payload: error
})

export const getOpenJobByCategoryRequest = (data) => ({
  type: DASHBOARD.GET_OPEN_JOB_BY_CATEGORY_REQUEST,
  payload: data
})

export const getOpenJobByCategorySuccess = (data) => ({
  type: DASHBOARD.GET_OPEN_JOB_BY_CATEGORY_SUCCESS,
  payload: data
})

export const getOpenJobByCategoryFailure = (error) => ({
  type: DASHBOARD.GET_OPEN_JOB_BY_CATEGORY_FAIL,
  payload: error
})

export const getTotalApplicantsFunnelRequest = (data) => ({
  type: DASHBOARD.GET_TOTAL_APPLICANTS_FUNNEL_REQUEST,
  payload: data
})

export const getTotalApplicantsFunnelSuccess = (data) => ({
  type: DASHBOARD.GET_TOTAL_APPLICANTS_FUNNEL_SUCCESS,
  payload: data
})

export const getTotalApplicantsFunnelFailure = (error) => ({
  type: DASHBOARD.GET_TOTAL_APPLICANTS_FUNNEL_FAIL,
  payload: error
})

export const getApplicationsReceivedByCategoryRequest = (data) => ({
  type: DASHBOARD.GET_APPLICATIONS_RECEIVED_BY_CATEGORY_REQUEST,
  payload: data
})

export const getApplicationsReceivedByCategorySuccess = (data) => ({
  type: DASHBOARD.GET_APPLICATIONS_RECEIVED_BY_CATEGORY_SUCCESS,
  payload: data
})

export const getApplicationsReceivedByCategoryFailure = (error) => ({
  type: DASHBOARD.GET_APPLICATIONS_RECEIVED_BY_CATEGORY_FAIL,
  payload: error
})

export const getJobPostByJobTypeRequest = (data) => ({
  type: DASHBOARD.GET_JOB_POST_BY_JOB_TYPE_REQUEST,
  payload: data
})

export const getJobPostByJobTypeSuccess = (data) => ({
  type: DASHBOARD.GET_JOB_POST_BY_JOB_TYPE_SUCCESS,
  payload: data
})

export const getJobPostByJobTypeFailure = (error) => ({
  type: DASHBOARD.GET_JOB_POST_BY_JOB_TYPE_FAIL,
  payload: error
})

export const getJobAcceptedRatioRequest = (data) => ({
  type: DASHBOARD.GET_JOB_ACCEPTED_RATIO_REQUEST,
  payload: data
})

export const getJobAcceptedRatioSuccess = (data) => ({
  type: DASHBOARD.GET_JOB_ACCEPTED_RATIO_SUCCESS,
  payload: data
})

export const getJobAcceptedRatioFailure = (error) => ({
  type: DASHBOARD.GET_JOB_ACCEPTED_RATIO_FAIL,
  payload: error
})

export const getJobByTitleRequest = (data) => ({
  type: DASHBOARD.GET_JOB_BY_TITLE_REQUEST,
  payload: data
})

export const getJobByTitleSuccess = (data) => ({
  type: DASHBOARD.GET_JOB_BY_TITLE_SUCCESS,
  payload: data
})

export const getJobByTitleFailure = (error) => ({
  type: DASHBOARD.GET_JOB_BY_TITLE_FAIL,
  payload: error
})

export const getLocationDataRequest = (data) => ({
  type: DASHBOARD.GET_LOCATION_DATA_REQUEST,
  payload: data
})

export const getLocationDataSuccess = (data) => ({
  type: DASHBOARD.GET_LOCATION_DATA_SUCCESS,
  payload: data
})

export const getLocationDataFailure = (error) => ({
  type: DASHBOARD.GET_LOCATION_DATA_FAIL,
  payload: error
})

export const getApplicantByGenderRequest = (data) => ({
  type: DASHBOARD.GET_APPLICANT_BY_GENDER_REQUEST,
  payload: data
})

export const getApplicantByGenderSuccess = (data) => ({
  type: DASHBOARD.GET_APPLICANT_BY_GENDER_SUCCESS,
  payload: data
})

export const getApplicantByGenderFailure = (error) => ({
  type: DASHBOARD.GET_APPLICANT_BY_GENDER_FAIL,
  payload: error
})
